import React, { useEffect, useState } from "react";

import Config from "../../config";
import UsersTable from "./UsersTable";
import Spinner from "../../components/Spinner";
import Error from "../../components/Error";
import Wrapper from "../../components/Wrapper";
import CustomButton from "../../components/CustomButton";
import Pagination from "../../components/Pagination";
import { TextField } from "@aws-amplify/ui-react";

import { ScrollView, Flex } from "@aws-amplify/ui-react";
import { useContx } from "../../AuthProvider";
import { MdSearch } from "react-icons/md";
import { IoCloseCircle } from "react-icons/io5";

const UsersTablePage = () => {
  const {
    isAdmin,
    isUser,
    users,
    getUsers,
    error,
    loading,
    pagination,
    totals,
  } = useContx();

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    (isAdmin || isUser) && getUsers(1);
    //eslint-disable-next-line
  }, []);

  const handleSearch = async () => {
    await getUsers(1, searchTerm);
  };

  const handleClear = () => {
    setSearchTerm("");
    getUsers(1, "");
  };

  let content = (
    <>
      <Flex alignItems="center" padding={10}>
        <CustomButton
          path={Config.routes.addUser}
          state={isUser ? "Operator" : "User"}
          check={isAdmin || isUser}
        />
      </Flex>
      <Flex direction="row" alignItems="center" gap="0.25rem">
        <div style={{ display: 'flex', position: "relative", width: "100%", maxWidth: "500px", paddingBottom: "2%", gap: "1%" }}>
          <TextField
            label="Search"
            placeholder="Search by name or email"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await getUsers(1, searchTerm);
              }
            }}
            width="100%"
          />
          {searchTerm && (
            <IoCloseCircle
              style={{
                cursor: "pointer",
                fontSize: "2.5rem",
                color: "gray",
                alignSelf: "end",
              }}
              onClick={handleClear}
            />
          )}
          <MdSearch
            style={{
              cursor: "pointer",
              fontSize: "2.5rem",
              color: "gray",
              alignSelf: "end",
            }}
            onClick={handleSearch}
          />
        </div>
      </Flex>
      <Wrapper>
        <br />
        <ScrollView width="100%">
          <UsersTable users={users} />
          <Pagination
            fn={getUsers}
            cp={pagination?.users?.currentPage}
            pp={pagination?.perPage}
            t={totals?.users?.total}
            v={totals?.users?.visited}
          />
        </ScrollView>
      </Wrapper>
    </>
  );

  if (loading) {
    content = <Spinner />;
  }

  if (error) {
    return <Error message={error} />;
  }

  return content;
};

export default UsersTablePage;